<template>
  <section id="section-faq">
    <SectionHeading id="toc-faq" class="heading" icon="icon-multiple-users-1" title="FAQ" />

    <div class="faq" v-for="faq in faqs" :class="{ collapsed: !faq.show }">
      <div class="faq-heading" @click="faq.show = !faq.show">
        <div>{{ faq.title }}</div>
        <i class="icon icon-arrow-down-1"></i>
      </div>

      <div v-if="faq.show" class="faq-description" v-html="parseMarkdown(faq.description)"></div>
    </div>
  </section>
</template>

<script setup>
import { useItineraryStore } from '@/stores/itinerary.js'
import SectionHeading from '@/modules/Itinerary/Components/SectionHeading.vue'
import { parseMarkdown } from '@/utils'

const store = useItineraryStore()
const {
  data: { faqs },
} = store
store.monitorVisibility('faq', '#section-faq')
</script>

<style lang="scss" scoped>
.heading {
  margin-bottom: 4px;
}

.faq-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  cursor: pointer;
  user-select: none;
  padding-block: 16px;
  gap: 16px;
}

.faq-description {
  font-weight: 400;
  padding-bottom: 16px;
  &:deep {
    @include markdown-display;
  }
}

.faq:last-child.collapsed .faq-heading,
.faq:last-child .faq-description {
  padding-bottom: 0;
}

.faq:not(:last-child) {
  border-bottom: 1px solid $gray-lighter;
}

.icon {
  transform: rotate(180deg);
  transition: transform 100ms ease-in;
}

.collapsed .icon {
  transform: rotate(0);
}
</style>
